import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=0f205d32&scoped=true"
import script from "./EventsTable.vue?vue&type=script&lang=js"
export * from "./EventsTable.vue?vue&type=script&lang=js"
import style0 from "./EventsTable.scss?vue&type=style&index=0&id=0f205d32&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f205d32",
  null
  
)

export default component.exports